import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const verifyOtp = createAsyncThunk(
  "verifyOtp/verifyOtpUsers",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("verify-otp", payload);
      return response.data;
    } catch (error) {
     
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
      
    }
  }
);

const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        console.log({action});
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default verifyOtpSlice.reducer;
